// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2uMm6","actionsCol":"EnrolledClinics_actionsCol__A3-qc"};